let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ctZCD"), load("3m9re")]).then(() => parcelRequire('hHfH9'));